import styled from "styled-components";

export const MasterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
  max-width: 1400px;
`;

export const LoaderWrapper = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ErrorWrapper = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  padding: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  padding-bottom: 64px;
`; 